export default __webpack_public_path__ + "media/Compass_right.3890aa6eac42a5676ed746fb9ace9d1e.svg";